/**
 * Tour 4: Advanced Features — "Power user features"
 */

const TOUR_ID = "advanced-features";

/** @param {{ t: (key: string, opts?: object) => string }} deps */
export function getAdvancedFeaturesSteps({ t }) {
  return {
    id: TOUR_ID,
    label: t("Advanced Features", { defaultValue: "Advanced Features" }),
    description: t("Power user features", {
      defaultValue: "Power user features",
    }),
    steps: [
      {
        element: '[data-tour="action-reset"]',
        popover: {
          title: t("Reset Canvas", { defaultValue: "Reset Canvas" }),
          description: t(
            "Clear all devices and connections from the canvas. Useful when you want a clean slate.",
            {
              defaultValue:
                "Clear all devices and connections from the canvas. Useful when you want a clean slate.",
            },
          ),
          side: "bottom",
          align: "center",
        },
      },
      {
        element: '[data-tour="canvas-filter-toggle"]',
        popover: {
          title: t("Toggle Detail Level", {
            defaultValue: "Toggle Detail Level",
          }),
          description: t(
            "Switch between showing only key fields (hostname, IP) and showing all metadata fields on each device node.",
            {
              defaultValue:
                "Switch between showing only key fields (hostname, IP) and showing all metadata fields on each device node.",
            },
          ),
          side: "right",
          align: "center",
        },
      },

      {
        element: '[data-tour="ai-chat"]',
        popover: {
          title: t("Revert to Checkpoint", { defaultValue: "Revert to Checkpoint" }),
          description: t(
            "Each message you send creates a checkpoint. Hover over any of your messages to see a revert button — click it to roll back the canvas to that point.",
            {
              defaultValue:
                "Each message you send creates a checkpoint. Hover over any of your messages to see a revert button — click it to roll back the canvas to that point.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="ai-chat"]',
        popover: {
          title: t("View Plan", { defaultValue: "View Plan" }),
          description: t(
            "When using Plan mode, the AI drafts a plan before building. Look for the 'view plan' link on plan messages to review, approve, revise, or cancel the proposed changes.",
            {
              defaultValue:
                "When using Plan mode, the AI drafts a plan before building. Look for the 'view plan' link on plan messages to review, approve, revise, or cancel the proposed changes.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="chat-example-prompts"]',
        popover: {
          title: t("Example Prompts", { defaultValue: "Example Prompts" }),
          description: t(
            "Not sure where to start? Click any example prompt to send it directly to the AI.",
            {
              defaultValue:
                "Not sure where to start? Click any example prompt to send it directly to the AI.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="device-palette-search"]',
        popover: {
          title: t("Search Device Library", {
            defaultValue: "Search Device Library",
          }),
          description: t(
            "Filter the device library by name, type, or category to quickly find the right device.",
            {
              defaultValue:
                "Filter the device library by name, type, or category to quickly find the right device.",
            },
          ),
          side: "left",
          align: "start",
        },
      },
      {
        element: '[data-tour="device-palette-view-toggle"]',
        popover: {
          title: t("View Mode", { defaultValue: "View Mode" }),
          description: t(
            "Switch between grid and list views for the device library. Use whichever layout works best for you.",
            {
              defaultValue:
                "Switch between grid and list views for the device library. Use whichever layout works best for you.",
            },
          ),
          side: "left",
          align: "start",
        },
      },
    ],
  };
}

export default getAdvancedFeaturesSteps;
